module.exports = __webpack_public_path__ + "80f41c19981f3275c438ea75ecbafd8c.svg";